<fa-icon *ngIf="getDataPointTypeIcon(type) as icon" [icon]="icon"></fa-icon>
